angular.module('frontyard_app', [
    'iw.frontyard.app',
    'iw.frontyard.error',
    'iw.frontyard.repayment_calculator',
]).config(function whiteListForIwocaCDN($sceDelegateProvider) {
    var sameOriginResource = 'self';
    var staticIwocaCDN = 'https://static.iwoca.com/**';

    $sceDelegateProvider.resourceUrlWhitelist([
        sameOriginResource,
        staticIwocaCDN
    ]);
});